import { render, staticRenderFns } from "./Armip.vue?vue&type=template&id=346e5349&"
import script from "./Armip.vue?vue&type=script&lang=js&"
export * from "./Armip.vue?vue&type=script&lang=js&"
import style0 from "./Armip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports